import NumberFlow, {continuous} from "@number-flow/react";
import {ArrowUpRightIcon, ArrowDownRightIcon} from "@phosphor-icons/react/dist/ssr";
import {useData} from "context/data.context";
import {CURRENCY_LONG, LOCALE} from "utilities/global.variables";
import {formatCurrency, formatPercent} from "utilities/global.functions";

const NetworthCard = () => {
  const { networthCurrent } = useData();

  const networth = networthCurrent.total ?? 0;
  const growth = networthCurrent.ytd ?? 0;
  const percent = networthCurrent.ytdPercent ?? 0;
  const type = growth >= 0 ? "up" : "down";
  const arrow = growth >= 0 ? <ArrowUpRightIcon size={10} /> : <ArrowDownRightIcon size={10} />;

  return (
    <div className="Total">
      <div className="padding flex row space">
        <div className="flex col small-gap">
          <NumberFlow className="number xxxlarge" plugins={[continuous]} locales={LOCALE} format={CURRENCY_LONG} value={networth} />

          {growth !== null && (
            <div className="flex row center medium-gap">
              <div className={"flex row center small-gap flag " + type}>
                {arrow}
                <p className="regular">{formatPercent(percent)}</p>
              </div>
              <p className="medium o90">{formatCurrency(growth)} this year</p>
            </div>
          )}
        </div>

      </div>
    </div>
  );
};
export default NetworthCard;
